module.exports = __webpack_public_path__ + "img/logo_sistema.85f6900c.jpg";